//export const API = "http://localhost:8001/api";

export const API = process.env.REACT_APP_API_URL;
// process.env.REACT_APP_API_URL;
// 'http://localhost:8000/api'
